import { Helmet } from 'react-helmet-async';

import SingleCardTemplate from '@/components/layouts/SingleCardTemplate';
import { pageTitles } from '@/constants/pageTitles';
import EmailConfirmation from '@/features/forgot/components/EmailConfirmation';

const PasswordChangeEmailConfirmationPage: React.FC = () => (
  <SingleCardTemplate title="ログインできない理由はなんですか？">
    <Helmet>
      <title>{pageTitles.forgotPasswordConfirmation}</title>
    </Helmet>
    <EmailConfirmation />
  </SingleCardTemplate>
);

export default PasswordChangeEmailConfirmationPage;
